import React from 'react';
import { Navigate } from 'react-router-dom';
import { USER_TYPES, ROUTE_PERMISSIONS } from './routeConfig';
import { isSuperadmin } from '../utils/constants';


// handles access control based on configs provided. ideally – non changable logic part
export const ProtectedRoute = ({ 
  element, 
  permission, 
  auth,
  setAuth,
  isSidebarOpen,
  fallbackPath = '/credits',
  ...rest 
}) => {
  const hasPermission = checkPermission(auth, permission);  
  if (!hasPermission) {
    return <Navigate to={fallbackPath} replace />;
  }

  return React.cloneElement(element, { auth, setAuth, isSidebarOpen, ...rest });
};


const checkPermission = (auth, requiredPermission) => {
  // For public routes, no authentication needed
  if (requiredPermission === ROUTE_PERMISSIONS.PUBLIC) {
    return true;
  }

  // For all other routes, user must be logged in
  if (!auth?.isLoggedIn) {
    return false;
  }

  // For authenticated routes, just being logged in is enough
  if (requiredPermission === ROUTE_PERMISSIONS.AUTHENTICATED) {
    return true;
  }

  // For role-specific routes, userType must be defined and valid
  const userType = auth.userType;
  if (!userType || !Object.values(USER_TYPES).includes(userType)) {
    console.warn('ProtectedRoute: Invalid or undefined userType:', userType);
    return false;
  }

  switch (requiredPermission) {
    case ROUTE_PERMISSIONS.TENANT:
      return userType === USER_TYPES.TENANT;
    
    case ROUTE_PERMISSIONS.WHOLESALER:
      return userType === USER_TYPES.WHOLESALER;

    // Permission-group gate, independent of the portal (user type).
    case ROUTE_PERMISSIONS.SUPERADMIN:
      return isSuperadmin(auth);

    default:
      return false;
  }
};

export default ProtectedRoute;
